'use client'

import React from 'react'
import { formatDistanceToNow } from 'date-fns'
import Link from 'next/link'
import { cn } from '@scalis/utils'
import { ActionButton, Avatar, AvatarVariantSizeEnum } from '~/scalis-components/core'
import { Body, BodySize, Caption, CaptionColor, CaptionType } from '~/scalis-components/core/typography'
import { getNotificationLink } from '../../navbar-template.utils'
import { NavbarNotificationsDrawerItemProps } from './navbar-notifications-drawer-item.types'
import { getNotificationRichDescription } from './utils/get-notification-rich-description/get-notification-rich-description'

const NavbarNotificationsDrawerItem = ({
  item,
  hasBottomBorder = true,
  onMarkAsReadClick,
  onMarkAsUnreadClick,
}: NavbarNotificationsDrawerItemProps) => {
  const isUnread = item.read_at === null

  const actionItems = [
    isUnread
      ? {
          label: 'Mark as read',
          onClick: onMarkAsReadClick,
          icon: 'fa-regular fa-check-double',
        }
      : {
          label: 'Mark as unread',
          onClick: onMarkAsUnreadClick,
          icon: 'fa-regular fa-circle-minus',
        },
  ]

  return (
    <div
      className={cn(
        'flex flex-col gap-2 p-4 hover:bg-brand-primary-light-10 hover:cursor-pointer',
        isUnread && 'bg-brand-primary-light-00',
        hasBottomBorder && 'border-b border-neutral-00',
      )}
    >
      <Link href={getNotificationLink(item)}>
        <div className='flex items-center gap-2'>
          <div className='relative'>
            <Avatar
              size={AvatarVariantSizeEnum.Medium}
              src={undefined}
              fullName={item.data?.title ?? undefined}
              className='ring-0'
            />
            {isUnread && (
              <div
                data-testid='unread-indicator'
                className='absolute top-0 right-0.5 h-[8px] w-[8px] rounded-full bg-brand-primary-00 border border-bg-brand-primary-light-00 '
              />
            )}
          </div>
          <div className='flex flex-col flex-1'>
            <div className='flex justify-between items-center gap-2'>
              <Body>{item.data?.title}</Body>
              <ActionButton
                actionsItems={actionItems}
                asButtonIcon
              />
            </div>
            {item.inserted_at && (
              <Caption
                type={CaptionType.basic}
                color={CaptionColor.secondary}
                className='text-xs mt-1'
              >
                {`${formatDistanceToNow(item.inserted_at)} ago`}
              </Caption>
            )}
          </div>
        </div>
        <Body size={BodySize.small}>{getNotificationRichDescription(item)}</Body>
      </Link>
    </div>
  )
}

export default NavbarNotificationsDrawerItem
